import { useGetOCSortingFields } from '../../screens/Claims/OverCharge/hooks';
import FormSelectBox from '../Inputs/FormSelectBox';

const OverChargeSortingSelector = ({
  placeholder = 'Select Sort By',
  label = 'Sort By',
  rules = [],
  name,
  editMode,
}) => {
  const { data = [], isLoading } = useGetOCSortingFields();
  const options = data.map((row) => ({
    label: row.value,
    value: row.key,
  }));

  return (
    <FormSelectBox
      loading={isLoading}
      options={options}
      placeholder={placeholder}
      label={label}
      margin="mb-0"
      rules={rules}
      name={name}
      editMode={editMode}
    />
  );
};

export default OverChargeSortingSelector;
